<template>
  <div class="Wdgt-Auth-Module">
    <p class="Wdgt-Auth-Module__text Wdgt-Auth-Module__text--thin">Вход по ссылке</p>
    <TypographyHint class="Wdgt-Auth-Module__hint">Введите свой e-mail — мы вышлем ссылку для входа без пароля.</TypographyHint>
    <form class="Wdgt-Auth-Module__form">
      <TextInput class="Wdgt-Auth-Module__form-field" v-model="email" :placeholder="'Адрес электронной почты'" :errorMessage="error" :name="'email'" @update-value="clearError"/>
      <ButtonMain class="Wdgt-Auth-Module__button" :width="'100%'" @click="toRequestLink" :loading="get_isLoading">Прислать ссылку</ButtonMain>
    </form>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
  import { useStore } from 'vuex';
  import { backendUrl } from "@shared/constants/urls/appUrls";
  import AUTH_SECTIONS_NAME from '@shared/constants/dropdowns/authSectionsName.js';
  //-----------------------
  import TypographyHint from '@ui/Typography/TypographyHint/TypographyHint.vue';
  import TextInput from '@shared/UI/Fields/TextInput/TextInput.vue';
  import ButtonMain from '@shared/UI/Buttons/ButtonMain/ButtonMain.vue';
  //-----------------------
  const store = useStore();
  //-----------------------
  const REQUEST_ENDPOINT = `${ backendUrl }/api/auth/magic-link/request/`;
  //-----------------------
  const error = ref();
  const email = ref('');
  //-----------------------
  onMounted(() => {
    window.addEventListener('keydown', onEnterKeyPress);
  });
  onBeforeUnmount(() => {
    window.removeEventListener('keydown', onEnterKeyPress);
  });
  //-----------------------
  //Статус отправки данных
  const get_isLoading = computed(() => store.state.AuthorizationSystem.isLoading);
  //-----------------------
  //Запросить отправку ссылки для входа на указанный e-mail
  const toRequestLink = async () => {
    if (get_isLoading.value) return;
    const value = email.value.trim();
    if (!value) { error.value = 'Введите e-mail'; return; }
    toChangeLoadingFlag(true);
    try {
      const response = await fetch(REQUEST_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: value }),
      });
      //Бэкенд всегда возвращает 200 (анти-энумерация), поэтому по .ok просто переключаем секцию,
      //не раскрывая, существует ли аккаунт с таким e-mail
      if (response.ok) {
        store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.MAGIC_LINK_SENT);
      } else {
        error.value = 'Не удалось отправить ссылку. Проверьте e-mail.';
      }
    } catch (err) {
      error.value = 'Ошибка сети: ' + err.message;
    } finally {
      toChangeLoadingFlag(false);
    }
  };
  //Очистить поле ошибки
  const clearError = () => { error.value = ''; };
  //Отметить процесс отправки данных на сервер
  const toChangeLoadingFlag = (status) => store.commit('AuthorizationSystem/toChangeLoadingFlag', status);
  //Глобальный обработчик для Enter
  const onEnterKeyPress = (e) => {
    const key = e.key || e.keyCode;
    if (key === 'Enter' || key === 13) {
      e.preventDefault();
      toRequestLink();
    }
  };
</script>

<style lang="scss">
  @import '../../styles/Wdgt-Auth-Module.scss';
</style>
